import React from 'react';
import {
  Box,
  Breadcrumbs,
  Grid,
  Paper,
  Typography,
  Link as MuiLink,
} from '@mui/material';
import PurchasesChart from './PurchasesChart';
import UsersByProductChart from './UsersByProductChart';
import UsersByPlatformChart from './UsersByPlatformChart';
import UsersByHostAppChart from './UsersByHostAppChart';
import RefundsChart from './RefundsChart';
import RecentUsersTable from './RecentUsersTable';

const Dashboard = () => {
  return (
    <Box
      sx={{
        pt: 0,
        pr: 3,
        pb: 3,
        pl: 3,
        backgroundColor: '#f5f5f5',
        minHeight: '100vh',
      }}
    >
      {/* <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>
        Admin Dashboard
      </Typography> */}

      {/* Breadcrumbs */}
      <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
        <MuiLink underline="hover" color="inherit" href="/#">
          Home
        </MuiLink>
        <Typography color="text.primary">Dashboard</Typography>
      </Breadcrumbs>

      <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ mb: 3 }}>
        Dashboard
      </Typography>

      <Grid container spacing={3}>
        {/* Purchases Chart */}
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ padding: 2 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              New Purchases (Last 7 Days)
            </Typography>
            <PurchasesChart />
          </Paper>
        </Grid>

        {/* Users by Product */}
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ padding: 2 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Users by Product
            </Typography>
            <UsersByProductChart />
          </Paper>
        </Grid>

        {/* Users by Platform */}
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ padding: 2 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Users by Platform (Win/Mac)
            </Typography>
            <UsersByPlatformChart />
          </Paper>
        </Grid>

        {/* Users by Host App */}
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ padding: 2 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Users by Host App
            </Typography>
            <UsersByHostAppChart />
          </Paper>
        </Grid>

        {/* Refunds Chart */}
        {/* <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ padding: 2 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Refunds
            </Typography>
            <RefundsChart />
          </Paper>
        </Grid> */}

        {/* Recent Users Table */}
        <Grid item xs={12}>
          <Paper elevation={3} sx={{ padding: 2 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Recent Users
            </Typography>
            <RecentUsersTable />
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;
